import React, { Component } from 'react';

export default class MetricsChartMenuItem extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        this.handleOnClick = this.handleOnClick.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    handleOnClick(chartName) {
        if (this.props.onClick != undefined) {
            this.props.onClick(chartName);
        }
    }

    render() {

        let icon = this.props.icon;
        if (icon === 'bell') {

            let iconStyle = { width: '100%', height: '100%', fill: 'rgba(0, 0, 0, 0)', stroke: '#555', strokeWidth: '25px' };
            let rectStyle = { fill: '#555', stroke: 'unset', strokeWidth: '0px' };
            let dotStyle = { fill: '#555', stroke: 'rgba(0, 0, 0, 0)', strokeWidth: '0px' };

            icon = (
                <svg version="1.1" style={iconStyle} id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 286 286" >
                    <path class="st0" d="M17.4,238.5c17.1-18.5,29.3-26,50.5-58.8c19.4-30.2,21.1-56.1,33.6-84c12.7-28.5,20.3-35.8,42-36.2c21.5-0.3,32.2,7.2,42,36.2c11.9,35,18,62.5,33.6,84c17.7,24.5,20.9,29.9,49.7,59.1" />
                    <rect style={rectStyle} x="8.1" y="229.8" width="269.7" height="23.4" />
                    <g id="Layer_4" style={dotStyle}>
                        <rect x="133.3" y="82.5" width="19.7" height="19.7" />
                        <rect x="133.3" y="122.3" width="19.7" height="19.7" />
                        <rect x="133.3" y="162" width="19.7" height="19.7" />
                        <rect x="133.3" y="201.6" width="19.7" height="19.7" />
                    </g>
                </svg>
            );
        }

        return (
            <div onClick={this.handleOnClick.bind(null, this.props.chart)} className="metrics-chart-item-outer">
                <div className="metrics-chart-item-icon material-icons">{icon}</div>
                <div className="metrics-chart-item-text">{this.props.text}</div>
            </div>
        );
    }
}